import React, { ComponentType, useEffect } from "react"
import { compose } from "@reduxjs/toolkit"
import { useTranslation } from "react-i18next"
import { useNavigate, useLocation } from "react-router-dom"

import { useAppDispatch } from "redux/hooks"
import { withCookieConsent } from "hocs/cookie"
import { Content, Card } from "pages/sessions/elements"
import Title from "components/Sessions/Title"
import Providers from "components/ui/Providers"
import Consent from "components/Sessions/Consent"
import { SessionConsentType } from "types"
import { updateRedirect } from "redux/features/auth/authSlice"
import { makeClientSignIn } from "redux/features/client/clientThunk"

type Props = {
  session: SessionConsentType
}

const LoginPage = ({ session }: Props) => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const location = useLocation()
  const { t } = useTranslation()

  useEffect(() => {
    const uriQuery = new URLSearchParams(location.search)
    const after = uriQuery.get("after")
    dispatch(updateRedirect({ redirect: after ? after : null }))

    const session_id = uriQuery.get("session")

    if (session_id) {
      dispatch(makeClientSignIn(session_id)).then(() => {
        navigate("/")
      })
    }
  }, [location])

  const { terms, privacy } = session
  const isDisabled = !(terms && privacy)

  const PROVIDERS = [
    {
      path: "/login/smart_id/new",
      title: t("providers.smart_id.title"),
    },
    {
      path: "/login/mobile_id/new",
      title: t("providers.mobile_id.title"),
    },
    {
      path: "/login/id_card/new",
      title: t("providers.id_card.title"),
    },
    // {
    //   path: "/login/banks/new",
    //   title: t("providers.banks.title"),
    // },
  ]

  const handleClick = (path: string) => {
    navigate(path)
  }

  return (
    <Content data-testid="login-page">
      <Card elevation={0}>
        <Title />
        <Providers
          light
          items={PROVIDERS}
          disabled={isDisabled}
          onClick={(path) => handleClick(path)}
        />
        <Consent />
      </Card>
    </Content>
  )
}

export default compose<ComponentType>(withCookieConsent)(LoginPage)
